



















































import {Component, Prop, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {BaseEvent, EventInitState, EventType, SeedEvent} from '@/store/event/event.types';
import {Files, FilesInitState, FileType, ReferenceID} from '@/store/files/files.types';
import {Helper} from '../../../util/helper';

@Component({
  components: {}
})
export default class NewsDetailComponent extends Vue {
  @State('event') eventState!: EventInitState;
  @State('file') filesInitState!: FilesInitState;
  @Action('_getFiles', {namespace: 'file'}) getFiles!: (payload: ReferenceID) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  @Prop({default: () => '' as string})
  public eventId!: string;

  @Watch('eventId')
  eventChange(val: string) {
    this.fetchEvent(val);
  }

  public lib: Helper = new Helper();
  public event = {} as SeedEvent;
  public listIMG = [{}] as Files[];

  async mounted() {
    await this.fetchEvent(this.eventId);
  }

  async fetchEvent(eventId: string) {
    this.Loading(true);
    let evenList = this.eventState.eventMember.concat(this.eventState.eventTime, this.eventState.eventMemberMain);
    this.event = evenList.filter((x) => x.id === eventId)[0];
    await this.getFiles({refId: this.event.imgRef, private: false, fileType: FileType.original});
    this.listIMG = this.filesInitState.files;
    this.Loading(false)

  }

  textHeader(eventType: string) {
    return eventType === EventType.forTime ? 'กิจกรรมคลังเวลา' : 'กิจกรรมสมาชิก';

  }

  goBack() {
    // this.$router.go(-1)
    this.$emit('close', true);
  }


}
